import { Text, TextVariant, Icon } from "@bridgesplit/ui";
import { formatAddress } from "@bridgesplit/utils";

export function WalletDisplaySmall({ address, variant }: { address: string | undefined; variant?: TextVariant }) {
    return (
        <Text variant={variant}>
            <Icon type="wallet" /> {formatAddress(address)}
        </Text>
    );
}
